export default __webpack_public_path__ + "static/media/enterprise-dynamic-20221009.0b3fd0fe.png";